import { style } from '@angular/animations';
import { Directive, ElementRef, HostListener } from '@angular/core';

@Directive({
  selector: '[appStickyTop]',
})
export class StickyTopDirective {
  private defaultOffsetTop: number;
  private elementHeight = 0;
  private notSticky = false;

  @HostListener('window:scroll', ['$event']) handleScroll(): void {
    const windowScroll = window.pageYOffset;
    let elementscroll = 0;
    let body = document.body,
      html = document.documentElement;
    let height = Math.max(
      body.scrollHeight,
      body.offsetHeight,
      html.clientHeight,
      html.scrollHeight,
      html.offsetHeight
    );

    if (!this.defaultOffsetTop) {
      if (this.el.nativeElement.nodeName === 'THEAD') {
        if (
          this.el.nativeElement.parentNode.clientHeight <
          window.innerHeight + 60
        ) {
          this.notSticky = true;
        }
        this.defaultOffsetTop = this.el.nativeElement.parentNode.offsetTop;
      } else {
        this.defaultOffsetTop = this.el.nativeElement.offsetTop;
      }
    }
    this.elementHeight = this.el.nativeElement.clientHeight;

    if (
      windowScroll + 70 >= this.defaultOffsetTop &&
      document.body.clientHeight +
        60 +
        this.elementHeight -
        this.defaultOffsetTop >
        html.clientHeight - 60 &&
      !this.notSticky
    ) {
      if (this.el.nativeElement) {
        this.el.nativeElement.classList.add('sticky');
        if (
          this.el.nativeElement.nextSibling &&
          this.el.nativeElement.nextSibling.style
        ) {
          // this.el.nativeElement.nextSibling.style.marginTop = `${this.elementHeight}px`;
        }
      }
    } else {
      if (this.el.nativeElement) {
        this.el.nativeElement.classList.remove('sticky');
        if (
          this.el.nativeElement.nextSibling &&
          this.el.nativeElement.nextSibling.style
        ) {
          // this.el.nativeElement.nextSibling.style.marginTop = 0;
        }
      }
    }
  }

  constructor(private el: ElementRef) {}
}
